import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveUserPayload } from "../types/userType";

export const getUserList = createAsyncThunk("/user/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/users?${query.toString()}`)).data;
  return response;
});

export const saveUser = createAsyncThunk("/user/save", async (payload: SaveUserPayload) => {
  const response = (await api.post("/users/action", payload)).data;
  return response;
});

export const deleteUser = createAsyncThunk("/user/delete", async (id: number) => {
  const response = (await api.get(`/users/delete/${id}`)).data;
  return response;
});
